/*
 * Exotic Snack Guys: slide-out cart drawer + mobile sticky add-to-cart polish.
 * Loaded from snippets/body-end-tag.liquid, after theme.js.
 *
 * - The theme still does the actual add to cart (it handles options, stock and errors).
 *   When its add succeeds, this script refreshes the drawer and opens it.
 * - The header cart icon opens the drawer instead of going to /cart.
 * - Quantity changes, removals and the "Substitute" choice are saved with Shopify's cart API.
 */
(function () {
  'use strict';
  if (window.esgCartDrawer) return;

  var SECTION = 'cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var HEADER_CART = '#site-control a.cart:not(.nav-search)';
  var MOBILE_MAX = 767;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function updateHeaderCount(count) {
    if (count === null || count === undefined || count === '') return;
    qsa(HEADER_CART).forEach(function (link) {
      var el = link.querySelector('div');
      if (el) el.textContent = count;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cart drawer                                                         */
  /* ------------------------------------------------------------------ */
  var drawer = document.getElementById('esg-cart-drawer');

  if (drawer) {
    var panel = qs('.esg-cd__panel', drawer);
    var lastFocus = null;
    var busy = false;
    var closeTimer = null;

    var isOpen = function () { return drawer.classList.contains('is-open'); };

    var lockScroll = function (on) {
      var s = window.theme && window.theme.viewport && window.theme.viewport.scroll;
      if (s && typeof s.lock === 'function' && typeof s.unlock === 'function') {
        if (on) { s.lock(); } else { s.unlock(); }
      } else {
        document.documentElement.classList.toggle('esg-cd-lock', on);
      }
    };

    var focusables = function () {
      return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])', panel)
        .filter(function (el) { return el.offsetWidth || el.offsetHeight; });
    };

    var onKey = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    };

    var open = function () {
      clearTimeout(closeTimer);
      if (isOpen()) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth; // paint the closed position first so the panel slides in
      drawer.classList.add('is-open');
      document.documentElement.classList.add('esg-cd-open');
      lockScroll(true);
      document.addEventListener('keydown', onKey);
      setTimeout(function () {
        var btn = qs('.esg-cd__close', drawer);
        (btn || panel).focus({ preventScroll: true });
      }, 60);
    };

    var close = function () {
      if (!isOpen()) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('esg-cd-open');
      lockScroll(false);
      document.removeEventListener('keydown', onKey);
      closeTimer = setTimeout(function () { drawer.hidden = true; }, 320);
      // Return focus to where the shopper was. The theme disables the Add to cart button while
      // adding, so fall back to that button once it is usable again.
      var back = lastFocus;
      if (!back || back === document.body || back.disabled || !document.contains(back)) {
        back = qs('.product-detail__form form.product-purchase-form [type="submit"]:not([disabled])');
      }
      if (back && back.focus) back.focus({ preventScroll: true });
    };

    var showError = function (msg) {
      var box = qs('[data-esg-cd-error]', drawer);
      if (!box) return;
      box.textContent = msg || 'Something went wrong. Please try again.';
      box.hidden = false;
    };

    var setBusy = function (on) {
      busy = on;
      drawer.classList.toggle('is-busy', on);
      if (panel) panel.setAttribute('aria-busy', on ? 'true' : 'false');
    };

    var render = function (html, focusInfo) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-esg-cd-inner]');
      var current = qs('[data-esg-cd-inner]', drawer);
      if (!fresh || !current) return;
      current.parentNode.replaceChild(document.importNode(fresh, true), current);
      updateHeaderCount(fresh.getAttribute('data-item-count'));
      if (focusInfo && isOpen()) {
        var target = focusInfo.key
          ? qs('[data-key="' + focusInfo.key + '"] [data-esg-action="' + focusInfo.action + '"]', drawer)
          : null;
        (target || qs('.esg-cd__close', drawer) || panel).focus({ preventScroll: true });
      }
    };

    var refresh = function () {
      return fetch(ROOT + '?sections=' + SECTION, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { if (!r.ok) throw new Error('Cart refresh failed'); return r.json(); })
        .then(function (data) { if (data && data[SECTION]) render(data[SECTION]); });
    };

    var changeQty = function (key, qty, action) {
      if (busy || !key) return;
      setBusy(true);
      var errBox = qs('[data-esg-cd-error]', drawer);
      if (errBox) errBox.hidden = true;

      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            return refresh().then(function () {
              showError(res.data && (res.data.description || res.data.message));
            });
          }
          var html = res.data && res.data.sections && res.data.sections[SECTION];
          var done = html ? Promise.resolve(render(html, { key: key, action: action })) : refresh();
          return done.then(function () {
            if (qty > 0 && res.data && res.data.items) {
              var line = res.data.items.filter(function (i) { return i.key === key; })[0];
              if (line && line.quantity < qty) {
                showError('Sorry, only ' + line.quantity + ' of this item ' + (line.quantity === 1 ? 'is' : 'are') + ' available.');
              }
            }
          });
        })
        .catch(function () { showError(); })
        .then(function () { setBusy(false); });
    };

    // Clicks inside the drawer: close, +/-, remove.
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-esg-cd-close]')) { e.preventDefault(); close(); return; }
      var btn = t.closest('[data-esg-qty]');
      if (!btn) return;
      e.preventDefault();
      var item = btn.closest('[data-key]');
      if (!item) return;
      changeQty(item.getAttribute('data-key'), parseInt(btn.getAttribute('data-esg-qty'), 10) || 0, btn.getAttribute('data-esg-action'));
    });

    // Substitution saving is shared with the full cart in cart-audit.js.
    // It serializes updates, exposes failures and guards navigation/checkout.

    // Checkout: stop double taps, show that something is happening.
    drawer.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-esg-cd-form]');
      if (!form) return;
      if (form.getAttribute('data-submitting') === '1') { e.preventDefault(); return; }
      form.setAttribute('data-submitting', '1');
      var btn = qs('.esg-cd__checkout', form);
      if (btn) btn.classList.add('is-loading');
    });

    // Header cart icon opens the drawer (a normal link to /cart if this script fails).
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest && e.target.closest(HEADER_CART);
      if (!link) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh().catch(function () {});
    }, true);

    // The theme's product-form add (product page, sticky bar, desktop quick view) uses jQuery.
    var onThemeAdd = function () {
      var quick = qs('#quick-buy-modal.reveal [data-modal-close]');
      var delay = 0;
      if (quick) { quick.click(); delay = 350; }
      refresh()
        .catch(function () {})
        .then(function () { setTimeout(function () { toast(); }, delay); });
    };
    if (window.jQuery) {
      window.jQuery(document).on('ajaxSuccess', function (event, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) onThemeAdd();
      });
    }

    // Grid "+ Add" buttons (theme.liquid) fire this event. Keep the drawer and count in sync without opening it.
    document.addEventListener('cart:updated', function () { refresh().catch(function () {}); });

    // Coming back with the browser's back button: resync.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      qsa('[data-esg-cd-form]', drawer).forEach(function (f) { f.removeAttribute('data-submitting'); });
      qsa('.esg-cd__checkout.is-loading', drawer).forEach(function (b) { b.classList.remove('is-loading'); });
      refresh().catch(function () {});
    });

    /* ESG Oct 29: after an add, show a small "Added to cart" notice under the header instead of sliding the cart open,
       so shoppers can keep scrolling. Tap "View cart" to open the drawer. To go back to opening the drawer,
       change toast() back to open() in onThemeAdd above and in afterAdd() in assets/esg.js. */
    var toastEl = null, toastTimer = null;
    var toast = function () {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'esg-added-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>' +
          '<span class="esg-added-toast__msg">Added to cart</span>' +
          '<button type="button" class="esg-added-toast__btn">View cart</button>';
        var css = document.createElement('style');
        css.textContent =
          '.esg-added-toast{position:fixed;left:50%;top:calc(var(--esg-stuck-h,0px) + 10px);z-index:70;display:flex;align-items:center;gap:10px;' +
          'max-width:calc(100vw - 24px);padding:8px 8px 8px 14px;border-radius:999px;background:#1d1a24;color:#fff;font-size:14px;font-weight:700;' +
          'box-shadow:0 10px 28px rgba(0,0,0,.22);opacity:0;pointer-events:none;transform:translate(-50%,-8px);transition:opacity .2s ease,transform .2s ease}' +
          '.esg-added-toast.is-on{opacity:1;pointer-events:auto;transform:translate(-50%,0)}' +
          '.esg-added-toast svg{width:18px;height:18px;flex:0 0 auto;color:#5fe39a}' +
          '.esg-added-toast__msg{white-space:nowrap}' +
          '.esg-added-toast__btn{border:0;border-radius:999px;padding:8px 14px;background:linear-gradient(90deg,#d6336c,#7b3fe4);color:#fff;font:inherit;font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap}' +
          '@media (prefers-reduced-motion:reduce){.esg-added-toast{transition:none}}' +
          '.esg-qa-added{pointer-events:none}';
        document.head.appendChild(css);
        document.body.appendChild(toastEl);
        toastEl.querySelector('button').addEventListener('click', function () {
          toastEl.classList.remove('is-on');
          open();
        });
      }
      clearTimeout(toastTimer);
      toastEl.classList.add('is-on');
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
    };

    window.esgCartDrawer = { open: open, close: close, refresh: refresh, toast: toast };
  }

  /* ------------------------------------------------------------------ */
  /* Mobile sticky add-to-cart (theme setting "Show a sticky Add to     */
  /* Cart button on mobile")                                             */
  /* ------------------------------------------------------------------ */
  var initSticky = function () {
    var bar = qs('.product-area__add-to-cart-xs');
    if (!bar || bar.hasAttribute('data-esg-sticky')) return;
    bar.setAttribute('data-esg-sticky', '');
    bar.classList.add('esg-sticky');

    var area = bar.closest('.product-area') || document;
    var priceArea = qs('.price-area', area) || qs('.product-area .price-area');
    var mainBtn = qs('.product-detail__form form.product-purchase-form [type="submit"]', area) ||
      qs('.product-detail__form form.product-purchase-form [type="submit"]');

    // Price next to the button, kept in step with the selected option.
    var priceEl = document.createElement('div');
    priceEl.className = 'esg-sticky__price';
    priceEl.setAttribute('aria-hidden', 'true');
    bar.insertBefore(priceEl, bar.firstChild);

    var syncPrice = function () {
      var cur = priceArea && (priceArea.querySelector('.current-price') || priceArea);
      var text = cur ? cur.textContent.replace(/\s+/g, ' ').trim() : '';
      priceEl.textContent = text;
      bar.classList.toggle('esg-sticky--no-price', !text);
    };
    syncPrice();
    if (priceArea && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceArea, { childList: true, subtree: true, characterData: true });
    }

    // Tell the page whether the bar is showing (used to lift the chat button above it).
    var syncVisible = function () {
      var shown = window.innerWidth <= MOBILE_MAX &&
        !bar.classList.contains('-out') &&
        !bar.classList.contains('esg-sticky--hidden');
      document.documentElement.classList.toggle('esg-sticky-on', shown);
      if (shown) document.documentElement.style.setProperty('--esg-sticky-h', bar.offsetHeight + 'px');
    };

    // Hide the bar while the main Add to cart button is on screen.
    if (mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('esg-sticky--hidden', entries[entries.length - 1].isIntersecting);
        syncVisible();
      }).observe(mainBtn);
    }
    if (window.MutationObserver) {
      new MutationObserver(syncVisible).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', syncVisible);
    syncVisible();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
})();
